

export class LiveSession {
  id: number;
  name: string;
  siteSessionId: number;
  siteId: number;
  site: string;
  siteLatitude: number;
  siteLongitude: number;
  startTime: Date;
  description: string;
  siteSession: any;
  user: any;
  guestCount: number;
  owner: boolean;
  lastUserSessionHealthCheckTime: Date;
  lastCheckLatitude: number;
  lastCheckLongitude: number;
  outsideGeoFence: boolean;
  promptHealthCheck: boolean;
  workOrderId: number;
  workOrderDescription: string;
  workOrderLastModifiedDate: Date;
  workOrderCreatedDate: Date;
  assetName: string;
  lastHealthCheck: any;
  lastCheck: Date;
  healthCheckInterval: number;
  expectedCheckOffTime: any;
  fullName: string;
  login: string;
  maintenanceName: string;


  public deserialize(input: any): this {
    this.id = input.id;
    this.name = input.fullName;
    this.login = input.login;
    this.maintenanceName = input.maintenanceName;
    this.siteId = input.siteId;
    this.site = input.siteName;
    this.siteLatitude = input.siteLatitude;
    this.siteLongitude = input.siteLongitude;
    this.owner = input.owner;
    this.guestCount = input.guestCount;
    this.healthCheckInterval = input.healthCheckInterval;
    this.lastCheckLatitude =  input.lastCheckLatitude
    this.lastCheckLongitude = input.lastCheckLongitude;
    this.outsideGeoFence = input.outsideGeoFence;
    this.siteSessionId = input.siteSessionId;
    this.startTime = new Date(input.startTime);
    this.lastUserSessionHealthCheckTime = new Date(input.lastUserSessionHealthCheckTime);
    this.promptHealthCheck = input.promptHealthCheck;
    this.expectedCheckOffTime = input.expectedCheckOffTime;
    this.workOrderId = input.workOrderId;

    if (this.isWorkOrderSession()) {
      this.description = `WRK ${input.workOrderId} - ${input.workOrderDescription}`;
      this.workOrderLastModifiedDate = new Date(input.workOrderLastModifiedDate);
      this.workOrderCreatedDate = new Date(input.workOrderCreatedDate);
      this.assetName = input.assetName;
    } else {
      this.description = 'Site Session';
    }
    return this;
  }

  public isHealthCheckDue() {
    return (this.hasHealthCheckData() && this.healthCheckWasPrompted());
  }

  public isExpectedCheckOffDue() {
    return (new Date(this.expectedCheckOffTime)) < (new Date());
  }

  public isWorkOrderSession() {
    return !!this.workOrderId;
  }

  // the user checked themselves on, or responded to a health check at some point
  // if false, the user is probably an additional worker who has not interacted with the phone app
  private hasHealthCheckData() {
    return (this.lastUserSessionHealthCheckTime || this.outsideGeoFence);
  }

  private healthCheckWasPrompted() {
    return this.promptHealthCheck;
  }
};
